import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, TrendingUpIcon } from '../../components/ui/Icons';

const MarketAction: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in">
            {/* Breadcrumbs */}
            <nav className="flex items-center space-x-2 text-sm text-slate-500 mb-6">
                <Link to="/grow" className="hover:text-trade-primary transition-colors">Grow</Link>
                <ChevronRightIcon className="w-4 h-4" />
                <span className="text-slate-900 font-medium">Market Action</span>
            </nav>

            <div className="text-center py-20">
                <div className="w-24 h-24 bg-trade-primary/10 rounded-full flex items-center justify-center mx-auto mb-6 text-trade-primary">
                    <TrendingUpIcon className="w-12 h-12" />
                </div>
                <h1 className="text-3xl font-bold text-slate-900 mb-4">Live Market Action</h1>
                <p className="text-xl text-slate-600 max-w-2xl mx-auto">
                    Real-time market insights and live trading sessions are coming soon.
                </p>
                <div className="mt-8">
                    <span className="inline-flex items-center px-4 py-2 rounded-full font-medium bg-blue-50 text-blue-700">
                        Coming Q1 2025
                    </span>
                </div>
            </div>
        </div>
    );
};

export default MarketAction;
